/**
 * Experten-Profil Typen
 */

export interface ExpertProfile {
  id: string;
  userId: string;
  skills: (string | SkillItem)[];
  isPublished: boolean;
  experiences: ExpertExperience[];
  languages: ExpertLanguage[];
  projects: ExpertProject[];
  certifications: ExpertCertification[];
  attachments: ExpertAttachment[];
  createdAt: string;
  updatedAt: string;
}

export interface ExpertExperience {
  id: string;
  area: string;
  years: number;
  level?: string | null;
}

export interface ExpertLanguage {
  id: string;
  language: string;
  level: string;
}

export interface ExpertProject {
  id: string;
  fromMonth: number;
  fromYear: number;
  toMonth?: number | null;
  toYear?: number | null;
  isCurrent: boolean;
  role: string;
  tasks?: string | null;
  company?: string | null;
  companySize?: string | null;
  industry?: string | null;
}

export interface ExpertCertification {
  id: string;
  title: string;
  issuingBody: string;
  website?: string | null;
  issueYear: number;
}

export interface ExpertAttachment {
  id: string;
  filename: string;
  mimetype: string;
  size: number;
  createdAt: string;
}

/** Profil-Übersicht mit User-Daten (für die Liste) */
export interface ExpertProfileListItem {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  jobTitle?: string | null;
  department?: string | null;
  avatar?: string | null;
  skills: (string | SkillItem)[];
  experienceCount: number;
  projectCount: number;
  certificationCount: number;
}

export const LANGUAGE_LEVELS = [
  'Muttersprache',
  'Verhandlungssicher',
  'Fliessend',
  'Gut',
  'C2',
  'C1',
  'B2',
  'B1',
  'A2',
  'A1',
] as const;

export const EXPERIENCE_LEVELS = [
  'Experte',
  'Fortgeschritten',
  'Grundkenntnisse',
] as const;

export type SkillLevel = 'basic' | 'advanced' | 'expert';

export interface SkillItem {
  name: string;
  level: SkillLevel;
  sortOrder?: number;
}

export const SKILL_LEVELS: { value: SkillLevel; label: string; color?: string }[] = [
  { value: 'basic', label: 'Grundkenntnisse', color: '#94a3b8' },
  { value: 'advanced', label: 'Fortgeschritten', color: '#3b82f6' },
  { value: 'expert', label: 'Experte', color: '#8b5cf6' },
];

export const COMPANY_SIZES = [
  '1-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1000',
  '1001-5000',
  '5000+',
] as const;
